
import cfg from './cfg';
import ui from './ui';

let apiURL = '';

const headersPublic = { 'Content-Type': 'application/json' };
const headersPrivate =  {
    'Content-Type': 'application/json' ,
    Authorization: 'Bearer Token'
};

function setLang(langCode) {
    apiURL = cfg.apiURL + '/' + langCode + '/' + cfg.apiVer+'/';
}

function setToken(token) {
    headersPrivate.Authorization = 'Bearer '+token;
}


async function publicCall(method, url, data = null) {
    let payload = {
        method,
        headers:headersPublic
    };

    if(data)
        payload.body = JSON.stringify(data);
    console.log(payload.body);
    let response = await fetch(apiURL + url, payload);
    let json = await response.json();

    return json;
}


async function call(method, url, data = null, mustToastErrors=true) {
    let payload = {
        method ,
        headers: headersPrivate
    };

    if(data)
        payload.body = JSON.stringify(data);

    let response = await fetch(apiURL + url, payload);
    let json = await response.json();


    if (!response.ok ) {
        let errorMsg = json?.error?.message;
        if (errorMsg) {
            let properyName = json?.error?.property_name
            if (properyName)
                errorMsg = properyName+': ' +errorMsg;
        }
        else
            errorMsg = response?.statusText;

        json.errorMessage = errorMsg;

        if (mustToastErrors)
            ui.sendToastDanger(errorMsg);

        if(401==response.status)
            ui.emitLogout();
    }

    return json;
}

async function callRaw(method, url, data = null, mustToastErrors=true) {
    let payload = {
        method ,
        headers: headersPrivate
    };

    if(data)
        payload.body = JSON.stringify(data);
        let response = await fetch(apiURL + url, payload);

        try {
            let json = await response.json();
    
        if (!response.ok ) {{
            let errorMsg = json?.error?.message;
            if (errorMsg) {
                let properyName = json?.error?.property_name
                if (properyName)
                    errorMsg = properyName+': ' +errorMsg;
            }
            else
                errorMsg = response?.statusText;
    
            json.errorMessage = errorMsg;
    
            if (mustToastErrors)
                ui.sendToastDanger(errorMsg);
    
            if(401==response.status)
                ui.emitLogout();
        }
        return false;
        } 
        } catch (error) {
            return  await fetch(apiURL + url, payload);  
        }
       

    
}


async function postText( url, data = null ) {
    let payload = {
        method:'POST' ,
        headers: headersPrivate
    };

    if(data)
        payload.body = JSON.stringify(data);

    let response = await fetch(apiURL + url, payload);
    if (!response.ok) return null;
    return await response.text();
}




const url = '/tools/tx-entry';

async function list(url, options=null) {
    return await call('POST', url + '/list', options);
}

async function get(url) {
    return await call('GET', url);
}

async function getId(url, id) {
    return await call('POST', url+'/get', {id} );
}
async function getIdNoErrors(url, id) {
    return await call('POST', url+'/get', {id},false );
}

async function update(url, data=null) {
    return await call('PATCH', url, data);
}

async function create(url,data=null) {
    return await call('POST', url, data);
}


async function post(url,data=null) {
    return await call('POST', url, data);
}
async function postNoErrors(url,data=null) {
    return await call('POST', url, data,false);
}

async function deleteId(url,id) {
    return await call('DELETE', url, {id} );
}

// return await call('GET', url+'/id/'+id );
//return await call('DELETE', url+'/id/'+id );

setLang(cfg.defaultLang);

export default {
    publicCall,
    call, callRaw, postText,
    setLang, setToken,
    get, getId, list, update, create, post, deleteId,getIdNoErrors,postNoErrors
};

